const labels = {
  ip_country: 'ip_country',
  business_units: 'business_units',
  amount: 'amount',
  transactions: 'transactions'
}

export default labels
